import { HttpInterceptor, HttpRequest, HttpHandler, HttpUserEvent, HttpEvent } from "@angular/common/http";
import { Observable } from "rxjs/Observable";
import 'rxjs/add/operator/do';
import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { AsyncLocalStorage } from "angular-async-local-storage";
import { AlertService } from "../alert/alert.service";

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
    constructor(private router: Router,private localStorage: AsyncLocalStorage,private alertService: AlertService) { }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        if (req.headers.get('No-Auth') == "True")
            return next.handle(req.clone());
        const token =localStorage.getItem('token');
        if ( token === null || token === "null") {
            return next.handle(req.clone());  
        }
        else {
            const clonedreq = req.clone({
                headers: req.headers.set("Authorization", "Bearer " + token)
            });
            return next.handle(clonedreq)
                .do(
                    succ => { },
                    err => {
                        if (err.status === 401){
                            this.alertService.close()
                            localStorage.setItem('token',null);
                            this.localStorage.setItem('token', null).subscribe();
                            this.router.navigate(["/auth"]);
                            this.alertService.swalError('Falhou!', 'Não foi possível validar sua sessão. Faça o login novamente.')
                        }
                    }
                );
              
        }
    }
}


// WEBPACK FOOTER //
// /var/www/minha-netsul/src/app/auth/auth.interceptor.ts